import { Action } from "@ngrx/store";
import * as types from "./constants/cart.constant";
import { CartItemInterface, CartUpdateInterface, ProductAttributesInterface, RequestCartItemInterface } from '../../Entites/product.model';



// product details




export class UPDATE_CART_ACTION implements Action
{

   readonly type: string = types.update_cart;
   constructor( public data: CartUpdateInterface ){}

}



export class HasError implements Action
{
   readonly type: string = types.HasError;
   constructor( public data: string ){}
}


export class REQUEST_ADD_TO_CART_ACTION implements Action
{
   readonly type: string = types.add_to_cart;
   constructor( public data: RequestCartItemInterface ){}
}

export class SET_CART_ACTION implements Action
{

   readonly type: string = types.set_cart;
   constructor(public data: CartItemInterface[]){}

}
export class FETCH_CART_ACTION implements Action
{
   readonly type: string = types.fetch_cart;
   constructor(){}
}

export class CART_Loading implements Action
{

   readonly type: string = types.loading_cart;
   constructor(public data:boolean){}

}

export class REQUEST_CART_TOTAL_ACTION implements Action
{

   readonly type: string = types.request_cart_total;
   constructor(){}

}


export class RECALCULATE_CART_TOTAL_ACTION implements Action
{

   readonly type: string = types.recalculate_cart_total;
   constructor( public data: number ){}

}
export class REMOVE_FROM_CART_ACTION implements Action
{

   readonly type: string = types.remove_from_cart;
   constructor( public data: number ){}

}




export type ActionsUnion = REMOVE_FROM_CART_ACTION | SET_CART_ACTION | CART_Loading ;
